import { residentPwaLink } from '../../constants'

interface ResidentPwaNoticeProps {
  message: string
  linkText: string
  path?: string
  className?: string
}

// Points residents who land on a staff page to the resident PWA. Same tab, so Add to Home Screen works there.
const ResidentPwaNotice = ({ message, linkText, path = '/', className = '' }: ResidentPwaNoticeProps) => (
  <div
    className={`rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-600 dark:border-gray-700 dark:bg-dark-900 dark:text-gray-300 ${className}`}
  >
    <p>{message}</p>
    <a href={residentPwaLink(path)} className="mt-1 inline-block font-semibold text-black underline underline-offset-2 hover:text-gray-600 dark:text-white dark:hover:text-gray-300">
      {linkText} →
    </a>
  </div>
)

export default ResidentPwaNotice
